import { MODULE_I18_PREFIX } from '../config/i18.busy';

export const VERIFICATION_TASKS_MAIN_TABS_I18_PREFIX =
  `${MODULE_I18_PREFIX}.verificationTasks.mainTabs` as const;
export const VERIFICATION_TASKS_TABLE_I18_PREFIX =
  `${MODULE_I18_PREFIX}.verificationTasks.table` as const;
export const VERIFICATION_TASKS_MAIN_TABS = {
  NEW: 'new',
  ESCALATED: 'escalated',
  DONE: 'done'
} as const;
